import { render } from "./registerForm.vue?vue&type=template&id=51af5bc0&ts=true"
import script from "./registerForm.vue?vue&type=script&lang=ts"
export * from "./registerForm.vue?vue&type=script&lang=ts"

import "./registerForm.vue?vue&type=style&index=0&id=51af5bc0&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__